import { useState, useEffect } from 'react'
import { MessageCircle, Sparkles } from 'lucide-react'
import { useGoogleAnalytics } from '@/hooks/useGoogleAnalytics'

const WhatsAppButton = () => {
  const { trackWhatsAppClick } = useGoogleAnalytics()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Show button after 2 seconds
    const timer = setTimeout(() => setIsVisible(true), 2000)
    return () => clearTimeout(timer)
  }, [])

  const handleWhatsAppClick = () => {
    // Track WhatsApp click
    trackWhatsAppClick('floating_button')
    
    const phoneNumber = '+919834887259'
    const message = 'Hi! I\'m interested in learning more about CloudBlitz courses. Can you help me?'
    const whatsappUrl = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, '_blank')
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Main WhatsApp Button */}
      <div className="relative">
        <button
          onClick={handleWhatsAppClick}
          className="group relative flex items-center justify-center w-12 h-12 bg-gradient-to-br from-green-500 via-emerald-500 to-teal-500 rounded-2xl shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 border-2 border-white/30 backdrop-blur-sm"
          title="Chat with us on WhatsApp"
        >
          <MessageCircle className="w-5 h-5 text-white" />
          
          {/* Subtle Pulse Animation */}
          <div className="absolute inset-0 bg-green-400 rounded-2xl animate-ping opacity-10"></div>
          
          {/* Glow Effect */}
          <div className="absolute inset-0 bg-green-400 rounded-2xl blur-md opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
          
          {/* Sparkle Effect */}
          <div className="absolute -top-1 -right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <Sparkles className="w-3 h-3 text-yellow-300 animate-pulse" />
          </div>
        </button>

        {/* Floating Badge */}
        <div className="absolute -top-1 -right-1 bg-gradient-to-r from-red-500 to-pink-500 text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold animate-bounce shadow-sm">
          LIVE
        </div>
      </div>

      {/* Tooltip */}
      <div className="absolute bottom-16 right-0 bg-gray-900/90 backdrop-blur-sm text-white text-xs px-2 py-1.5 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap border border-white/10">
        Chat with us on WhatsApp!
        <div className="absolute top-full right-3 w-0 h-0 border-l-3 border-r-3 border-t-3 border-transparent border-t-gray-900/90"></div>
      </div>
    </div>
  )
}

export default WhatsAppButton 